
class CompanyType {
	
	constructor() {
		Vue.component('company-type',  () => import('../components/CompanyType.vue'));
	}

}

export default CompanyType;
